<template>
  <div class="md-layout" v-if="loaded">
    <div class="md-layout-item md-size-70 md-medium-size-100">
      <md-card>
        <md-icon v-if="working" class="text-info status-icon working"
          >cached</md-icon
        >
        <md-icon v-else class="text-success status-icon done">done</md-icon>
        <md-card-header class="md-card-header-icon md-card-header-brand">
          <div class="card-icon">
            <md-icon>collections_bookmark</md-icon>
          </div>
          <h3 class="title">Povezivanje</h3>
        </md-card-header>
        <md-card-content class="md-layout">
          <div
            class="md-layout-item md-medium-size-100"
            v-for="(param, paramIndex) in bindingParams"
            :key="paramIndex"
            :class="param.size ? 'md-size-' + param.size : 'md-size-100'"
          >
            <md-field v-if="param.type === 'select'">
              <label>{{ param.label }}</label>
              <md-select
                v-model="binding[param.name]"
                @input="sendParam({ name: 'bindingType' })"
              >
                <md-option
                  v-for="(option, index) in param.options"
                  :key="index"
                  :value="option.id"
                  >{{ option.label }}</md-option
                >
              </md-select>
            </md-field>

            <input-plus
              v-else-if="param.type === 'button_checkbox'"
              @close-dropdown="sendParam(param)"
              @open-dropdown="sendParam(param)"
              :values="{ defaultValue: 0, checkAgainst: binding[param.name] }"
            >
              <md-button
                class="checkbox-button"
                :class="[
                  binding[param.name]
                    ? 'selected-button-checkbox'
                    : 'deselected-button-checkbox',
                ]"
                @click="toggleChecked(param.name)"
                slot="title"
              >
                <md-icon>
                  {{ binding[param.name] ? 'done' : 'add' }}
                </md-icon>
                {{ param.label }}
                <span v-if="param.additionalParameters && binding[param.name]">
                  <span
                    v-for="(
                      addParam, index
                    ) in param.additionalParameters.flat()"
                    :key="index"
                  >
                    <span
                      class="button-params"
                      v-if="addParam.type === 'number'"
                    >
                      {{ `${addParam.label}` }} {{ binding[addParam.name] }}
                    </span>
                    <span
                      class="button-params"
                      v-else-if="
                        addParam.type === 'radio' && paramRequired(addParam)
                      "
                    >
                      {{ getParamLabels(addParam) }}
                    </span>
                    <span
                      class="button-params"
                      v-else-if="
                        addParam.type === 'select' && paramRequired(addParam)
                      "
                    >
                      {{ getParamLabels(addParam) }}
                    </span>
                    <span
                      class="button-params"
                      v-else-if="
                        addParam.type === 'checkbox' &&
                        paramRequired(addParam) &&
                        binding[addParam.name]
                      "
                    >
                      {{ `${addParam.label}` }}
                    </span>
                  </span>
                </span>
              </md-button>
              <ul v-if="param.additionalParameters" class="dropdown-menu">
                <li
                  v-for="(addParam, index) in param.additionalParameters"
                  :key="index"
                  class="md-layout no-wrap"
                >
                  <div v-for="(column, index) in addParam" :key="index">
                    <div class="md-layout-item" v-if="paramRequired(column)">
                      <div
                        v-if="column.type === 'number'"
                        class="md-layout-item"
                      >
                        <md-field>
                          <label>{{ column.label }}</label>
                          <md-input
                            v-model="binding[column.name]"
                            type="number"
                            :value="column.selected"
                            :min="column.min"
                            :step="column.step"
                          >
                          </md-input>
                        </md-field>
                      </div>

                      <div
                        v-else-if="column.type === 'radio'"
                        class="md-layout md-layout-item"
                      >
                        <md-field>
                          <div
                            v-for="(option, index) in column.options"
                            :key="index"
                            class="md-layout-item"
                          >
                            <md-radio
                              v-model="binding[column.name]"
                              :value="option.name"
                              :class="{ 'tooltip-cont': option.tooltip }"
                            >
                              {{ option.label }}
                              <span v-if="option.tooltip" class="tooltiptext">{{
                                option.tooltip
                              }}</span>
                            </md-radio>
                          </div>
                        </md-field>
                      </div>

                      <div
                        v-else-if="column.type === 'checkbox'"
                        class="md-layout md-layout-item"
                      >
                        <md-field>
                          <md-checkbox v-model="binding[column.name]">{{
                            column.label
                          }}</md-checkbox>
                        </md-field>
                      </div>

                      <div
                        v-else-if="column.type === 'select'"
                        class="md-layout md-layout-item"
                      >
                        <md-field>
                          <label>{{ column.label }}</label>
                          <md-select v-model="binding[column.name]">
                            <md-option
                              v-for="(option, index) in column.options"
                              :key="index"
                              :value="option.id"
                              >{{ option.label }}</md-option
                            >
                          </md-select>
                        </md-field>
                      </div>

                      <div
                        v-else-if="column.type === 'textarea'"
                        class="md-layout md-layout-item"
                      >
                        <md-field>
                          <label>{{ column.label }}</label>

                          <md-textarea
                            v-model="binding[column.name]"
                            :placeholder="column.placeholder"
                          >
                          </md-textarea>
                        </md-field>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </input-plus>

            <div v-else-if="param.type === 'checkbox'">
              <md-checkbox
                v-model="binding[param.name]"
                @change="sendParam(param)"
              >
                {{ param.label }}
              </md-checkbox>
            </div>

            <md-field v-else-if="param.type === 'radio'">
              <label class="radio-title">
                {{ param.label }}
              </label>
              <div>
                <md-radio
                  v-for="(option, index) in param.options"
                  v-model="binding[param.name]"
                  :key="index"
                  :value="option.name"
                  :checked="option.name === param.selected"
                  @change="sendParam(param)"
                >
                  {{ option.label }}
                </md-radio>
              </div>
            </md-field>

            <input-plus
              v-else-if="param.type === 'number'"
              :values="{ defaultValue: 0, checkAgainst: binding[param.name] }"
            >
              <md-field>
                <div class="md-layout">
                  <label>
                    {{ param.label }}
                  </label>
                  <md-input
                    v-model="binding[param.name]"
                    slot="title"
                    type="number"
                    :min="param.min"
                    :value="param.selected"
                    @blur="sendParam(param)"
                    @focus="setWorking"
                  >
                  </md-input>
                </div>
              </md-field>
            </input-plus>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <div class="md-layout-item md-size-30 md-medium-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-brand">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h3 class="title">Repromaterijal</h3>
        </md-card-header>
        <md-card-content>
          <md-table :value="materialData" class="table-striped">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Materijal"
                ><b>{{ item.label }}</b></md-table-cell
              >
              <md-table-cell md-label="Količina">{{
                item.amount
              }}</md-table-cell>
              <md-table-cell md-label="JM">{{ item.unit }}</md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import api from '../api/api.js';
import services from '@/api/services';
export default {
  data() {
    return {
      bindingParams: null,
      loaded: false,
      materialData: null,
      working: false,
      binding: {
        bindingType: null,
        sewing: null,
        stacking: null,
        stackingType: null,
        collecting: null,
        collectingType: null,
        gluing: null,
        gluingType: null,
        caching: null,
        cachingPaperId: null,
        bookmark: null,
        headband: null,
        backType: null,
        klamer: null,
        klamerType: null,
        spiral: null,
        spiralType: null,
        spiralThickness: null,
        spiralColor: null,
        knifeCutting: null,
        packaging: null,
        piecesPerPackage: null,
        otherWorkInHours: null,
        otherWorkHours: null,
        otherWorkInHoursDesc: '',
        otherWorkInPrice: null,
        otherWorkPrice: null,
        otherWorkInPriceDesc: '',
      },
    };
  },
  methods: {
    paramRequired(param) {
      if (param.require) {
        switch (param.require.function) {
          case 'equals':
            if (this.binding[param.require.variable] === param.require.compare)
              return true;
            else return false;

          default:
            return true;
        }
      } else {
        return true;
      }
    },
    setWorking() {
      window.setTimeout(() => {
        this.working = true;
      }, 80);
    },
    sendParam(param) {
      this.working = true;
      const tempParam = Object.assign(param);
      const requestParams = {};
      requestParams.option = tempParam.name;
      requestParams[tempParam.name] = this.binding[tempParam.name];
      if (this.binding[tempParam.name] && tempParam.additionalParameters) {
        tempParam.additionalParameters.flat().forEach((element) => {
          if (this.paramRequired(element)) {
            requestParams[element.name] = this.binding[element.name];
          }
        });
      }
      api
        .post(services.job.bindingOptional, requestParams)
        .then((data) => {
          if (data.bindingParams) {
            this.bindingParams = data.bindingParams;
          }
          if (data.job.binding) {
            for (const [key, value] of Object.entries(this.binding)) {
              if (key !== 'bindingType' && value === true) {
                this.binding[key] = null;
              }
            }

            for (const [key, value] of Object.entries(data.job.binding)) {
              if (typeof value === 'object' && key !== 'prices') {
                if (this.binding[key] !== undefined && key !== 'bindingType') {
                  this.binding[key] = true;
                }
                for (const [lowerKey, lowerValue] of Object.entries(value)) {
                  if (
                    this.binding[lowerKey] !== undefined &&
                    lowerKey !== 'name'
                  ) {
                    this.binding[lowerKey] = lowerValue;
                  }
                }
              } else if (this.binding[key] !== undefined) {
                this.binding[key] = value;
              }
            }
          }
          if (data.materialTable) {
            this.materialData = Object.values(data.materialTable);
          }
          this.$emit('new-calculation', true);
          this.working = false;
        })
        .catch((error) => {
          this.alertError(error);
          this.working = false;
        });
    },
    toggleChecked(param) {
      this.binding[param] = !this.binding[param];
    },
    getParamLabels(param) {
      if (
        param.options &&
        this.binding[param.name] &&
        this.paramRequired(param)
      ) {
        return param.options.find((el) => {
          if (param.type === 'select')
            return el.id === this.binding[param.name];
          else if (param.type === 'radio') {
            return el.name === this.binding[param.name];
          }
        })?.label;
      } else {
        return null;
      }
    },
    getBindingParams() {
      api
        .get(services.job.getBindingParam, { getBindingParams: true })
        .then((data) => {
          this.bindingParams = data.bindingParams;
          this.bindingParams.forEach((param) => {
            if (['dropdown', 'select'].includes(param.type) && param.selected)
              this.binding[param.name] = param.selected.id;
            else this.binding[param.name] = param.selected;
            if (param.additionalParameters) {
              param.additionalParameters.forEach((row) => {
                row.forEach((addParam) => {
                  if (
                    ['dropdown', 'select'].includes(addParam.type) &&
                    addParam.selected
                  )
                    this.binding[addParam.name] = addParam.selected.id;
                  else if (this.paramRequired(addParam)) {
                    this.binding[addParam.name] = addParam.selected;
                  }
                });
              });
            }
          });
          if (data.materialTable) {
            this.materialData = Object.values(data.materialTable);
          }
          this.loaded = true;
        });
    },
    // ,
    // bindingType() {
    //     this.sendParam({ name: "bindingType" })
    // }
  },
  mounted() {
    this.$parent.$on('submited-job', () => {
      this.getBindingParams();
    });
    this.getBindingParams();
  },
  destroyed() {
    this.$parent.$off();
  },
  watch: {
    'binding.stacking': {
      handler (to, from) {
        if (to && to !== from) {
          this.binding.stackingType = 'stacking_all';
        }
      },
      deep: true,
    },
    'binding.spiralThickness': {
      handler (to, from) {
        if (to && to !== from) {
          const additionalParameters = this.bindingParams
            .find((el) => el.name === 'spiral')
            .additionalParameters.flat();
          const currentColors = additionalParameters.find(
            (el) => el.require?.compare === to,
          );
          const chosenColor = currentColors.options.find(
            (el) => el.name === this.binding.spiralColor,
          );
          if (!chosenColor)
            this.binding.spiralColor = currentColors.options[0].name;
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/md/_variables.scss';
.checkbox-button {
  position: relative;
  width: 100%;
  min-width: 120px;
}
.tooltip-cont {
  position: relative;
}

.tooltip-cont .tooltiptext {
  visibility: hidden;
  width: 240px;
  background-color: $brand-primary;
  color: #fff;
  text-align: center;
  border: 1px solid white;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 150%;
  left: 50%;
  margin-left: -60px;
}

.tooltip-cont .tooltiptext::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 20%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: $brand-primary $brand-primary transparent transparent;
}

.tooltip-cont:hover .tooltiptext {
  visibility: visible;
}
</style>
